import facepaint from 'facepaint';

// this function is used for spacing, fontsize and line height,
// once design tokens have been established for the all of these categories
// then this function can be replaced with the tokens
/**
 * @deprecated, these can be replaced with constants
 */
var gs = function gs(times) {
  return "".concat(8 * times, "px");
};
/**
 * @deprecated, these can be replaced with constants
 */
var br = function br() {
  var times = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return "".concat(3 * times, "px");
};
/**
 * @deprecated, these can be replaced with constants
 */
var mq = facepaint(['@media(min-width: 576px)']);
export { gs, br, mq };
export var handleClickCommon = function handleClickCommon(event, onClick) {
  if (onClick) {
    event.preventDefault();
    event.stopPropagation();
    onClick(event);
  }
};